import { graphql } from '../../graphql';

export const getStaticFooterData = graphql(`
  query StaticFooterData {
    ...FooterDataFields
  }
`);
